import { CHEMISTRY_ANALYSIS_TIMELINE } from '../chemistryAnalysisTimeline';

export const CHEMISTRY_VIDEO_WIDTH = 720;
export const CHEMISTRY_VIDEO_HEIGHT = 1280;
export const CHEMISTRY_VIDEO_FPS = 30;
export const CHEMISTRY_VIDEO_CONTENT_END_MS = 10_500;
export const CHEMISTRY_VIDEO_DURATION_MS = 12_000;

const WEB_TIMELINE_END_MS = CHEMISTRY_ANALYSIS_TIMELINE.at(-1)?.end || 1;

export const CHEMISTRY_VIDEO_TIMELINE = [
  ...CHEMISTRY_ANALYSIS_TIMELINE.map((scene) => ({
    ...scene,
    start: Math.round((scene.start / WEB_TIMELINE_END_MS) * CHEMISTRY_VIDEO_CONTENT_END_MS),
    end: Math.round((scene.end / WEB_TIMELINE_END_MS) * CHEMISTRY_VIDEO_CONTENT_END_MS),
  })),
  { id: 'outro', start: CHEMISTRY_VIDEO_CONTENT_END_MS, end: CHEMISTRY_VIDEO_DURATION_MS },
];

export function getChemistryVideoScene(elapsedMs) {
  const boundedElapsed = Math.max(0, Math.min(elapsedMs, CHEMISTRY_VIDEO_DURATION_MS - 1));
  return CHEMISTRY_VIDEO_TIMELINE.find(
    (scene) => boundedElapsed >= scene.start && boundedElapsed < scene.end,
  ) || CHEMISTRY_VIDEO_TIMELINE.at(-1);
}

export function getChemistryVideoSceneProgress(elapsedMs, scene) {
  if (!scene) return 0;
  return Math.max(0, Math.min(1, (elapsedMs - scene.start) / Math.max(scene.end - scene.start, 1)));
}
